// src/utils/jwt.ts
export function isValidJWTFormat(token: unknown): token is string {
  if (!token || typeof token !== 'string') return false

  const parts = token.split('.')
  if (parts.length !== 3) return false

  const base64UrlRegex = /^[A-Za-z0-9_-]+$/
  return parts.every(p => p.length > 0 && base64UrlRegex.test(p))
}

// ✅ 兼容 default import
export default isValidJWTFormat
